import React from 'react';
import './Footer.css'; // Assurez-vous que le chemin est correct
import { FaFacebookF, FaInstagram, FaWhatsapp, FaTiktok } from 'react-icons/fa';

function Footer() {
  
  return (
    <div className="footer-basic">
 <footer class="footer">
  <div class="footer-top">
  <div class="footer-social">
  <a href="https://wa.me/212655760051" target="_blank" rel="noopener noreferrer">
  <i class="fab fa-whatsapp"></i>
</a>

      <a href="https://www.instagram.com/bio_cleaners_services/">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://www.tiktok.com/@bio_cleaners">
        <i class="fab fa-tiktok"></i>
      </a>
    </div>
  </div>

  <script src="https://kit.fontawesome.com/your-font-awesome-kit.js" crossorigin="anonymous"></script>
  <div class="footer-content">
    <div class="footer-left">
      <img src="head.png" alt="Logo" class="footer-logo"/>
      <p class="footer-description">
        Bienvenue chez <strong>Biocleaners Services</strong>, Expert en nettoyage à Agadir, Casablanca, et Marrakech.
Nos services professionnels garantissent un environnement propre,
sain et respectueux de l'environnement.
      </p>
    </div>
    <div class="footer-middle">
    <h4>Liens Rapides</h4>
<hr class="underline"/> 
<ul class="footer-links">
  <li><a href="/">Accueil</a></li>
  <li><a href="/AboutUs">À propos</a></li>
  <li><a href="/Services">Services</a></li>
  <li><a href="/Contact">Contact</a></li>
  <li><a href="/Book">Réservation</a></li>
</ul>
    </div>
    <div class="footer-right">
    <h4>Avez-vous des questions ?</h4>
<hr class="underline"/> 
<p><i class="fas fa-paper-plane"></i> Biocleaners@service.com</p>
<p><i class="fas fa-phone-alt"></i> +212 6 55 76 00 51</p>
<p>  <i class="fas fa-map-marker-alt"></i>Agadir(Siège) , Marrakech , Casablanca </p>
</div>
  </div>
  
  <script src="https://kit.fontawesome.com/your-font-awesome-kit.js" crossorigin="anonymous"></script>
  <div class="footer-bottom">
    <p>2024 &copy; All rights reserved by Biocleanersservices</p>
  </div>
</footer>

    </div>
  );
}

export default Footer;
